<div class="flex flex-row gap-3 -mr-4 text-xxs">
  <div class="ml-1 w-4">
    <img [alt]="userCombi().fromAPI.api.nameNormalized" src='assets/images/apps/{{userCombi().fromAPI.api.nameNormalized}}.svg' class='m-0 w-4 h-4 mt-1 inline'/>
  </div>
  <div class="leading-7">{{ userCombi().fromAPIAction.apiAction.name }}</div>
  <div class="pt-2 text-gray-300 fas fa-arrow-alt-circle-right" [title]="userCombi().id"></div>
  <div class="w-4">
    <img [alt]="userCombi().toAPI.api.nameNormalized" src='assets/images/apps/{{userCombi().toAPI.api.nameNormalized}}.svg' class='m-0 w-4 h-4 mt-1 inline'/>
  </div>
  <div class="leading-7">{{ userCombi().toAPIAction.apiAction.name }}</div>
</div>